/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom"; // Import useParams and Link
import OrderUserContext from "../OrderUserContext"; // Adjust the path to your context
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Typography,
  Avatar,
  TablePagination,
} from "@mui/material";
import { deepOrange } from "@mui/material/colors";
import "../../css/Dashboard.css";
import { RotatingLines } from "react-loader-spinner";
export default function CustomerDetails() {
  const { customer } = useContext(OrderUserContext); // Access the customer from context
  const { customerId } = useParams(); // Extract userId from URL
  const [joinedDate, setJoinedData] = useState("");
  const [page, setPage] = useState(0); // Pagination state for the current page
  const [rowsPerPage] = useState(10); // Rows per page (fixed at 10)
  // Find the user with the matching userId
  const Customer = customer.find((u) => u.customerId === customerId);
  const GetMonth = () => {
    const accountCreationDate = new Date(Customer?.createdAt);
    const today = new Date();
    // Calculate total months
    let totalMonths =
      (today.getFullYear() - accountCreationDate.getFullYear()) * 12 +
      (today.getMonth() - accountCreationDate.getMonth());
    // Adjust for partial month
    if (today.getDate() < accountCreationDate.getDate()) {
      totalMonths -= 1;
    }
    const timeDifference = today - accountCreationDate;
    const totalDays = Math.floor(timeDifference / (1000 * 60 * 60 * 24)); // Convert milliseconds to days
    // Output
    if (totalMonths < 1) {
      setJoinedData(`${totalDays + 1} Days `);
    } else {
      setJoinedData(`${totalMonths} Months`);
    }
  };
  useEffect(() => {
    GetMonth();
  }, []);

  if (!Customer) {
    return (
      <div
        className="relative h-[100vh] flex items-center justify-center"
        style={{ position: "relative", height: "100vh" }}
      >
        <div
          className=" flex items-center justify-center"
          style={{
            position: "absolute",
            height: "100vh",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <RotatingLines
            visible={true}
            height="150"
            width="150"
            color="red"
            strokeColor="#24425a"
            strokeWidth="5"
            animationDuration="0.75"
            ariaLabel="rotating-lines-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
      </div>
    );
  }

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Paginate the orders
  const paginatedOrders = Customer.orders.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <div className="customer-details">
      <Typography variant="h4" className="mx-3 py-1">
        Customer Details
      </Typography>
      <div className="row flex justify-center">
        <div className="col-xl-9 col-sm-12 card">
          <div className="px-5 m-3 card flex flex-row items-center gap-3">
            <Avatar sx={{ bgcolor: deepOrange[500] }} />
            <div className="flex flex-col">
              <Typography
                variant="h5"
                color="text.secondary"
                className="m-10 mt-1 pt-2 font-medium"
                style={{ fontWeight: "bold" }}
              >
                {Customer?.orders
                  .slice(0, 1)
                  .map((order) => order.deliveryAddress?.name || Customer.name)}
              </Typography>
              <p className="text-black">Customer For {joinedDate}</p>
            </div>
          </div>
          <hr />
          <div className="px-2" style={{ height: "63vh", overflowY: "auto" }}>
            <Typography
              variant="h6"
              className="text-[gray] font-medium mx-3 sticky top-0 bg-white"
            >
              Orders Placed
            </Typography>
            <TableContainer component={Paper} className="mt-5">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      className="text-lg text-[gray] font-medium"
                      style={{ color: "black", fontSize: "20px" }}
                    >
                      #
                    </TableCell>
                    <TableCell
                      className="text-lg text-[gray] font-medium"
                      style={{ color: "black", fontSize: "20px" }}
                    >
                      Order ID
                    </TableCell>
                    <TableCell
                      className="text-lg text-[gray] font-medium"
                      style={{ color: "black", fontSize: "20px" }}
                    >
                      Order Date
                    </TableCell>
                    <TableCell
                      className="text-lg text-[gray] font-medium"
                      style={{ color: "black", fontSize: "20px" }}
                    >
                      Status
                    </TableCell>
                    <TableCell
                      className="text-lg text-[gray] font-medium"
                      style={{ color: "black", fontSize: "20px" }}
                    >
                      Payment Method
                    </TableCell>
                    <TableCell
                      className="text-lg text-[gray] font-medium"
                      style={{ color: "black", fontSize: "20px" }}
                    >
                      Total Price
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedOrders.map((order, index) => (
                    <TableRow
                      key={order._id}
                      sx={{
                        borderBottom: "1.5px solid gray",
                        backgroundColor:
                          index % 2 === 0
                            ? "#f2f2f2 !important"
                            : "#ffffff !important",
                        margin: "10px 0",
                      }}
                    >
                      <TableCell>{page * rowsPerPage + index + 1}.</TableCell>
                      <TableCell>
                        <Link to={`/order-details/${order.orderId}`}>
                          {order.orderId.toUpperCase()}
                        </Link>
                      </TableCell>
                      <TableCell>
                        {new Intl.DateTimeFormat("en-US", {
                          day: "numeric",
                          month: "long",
                          year: "numeric",
                        }).format(new Date(order.createdAt))}
                      </TableCell>

                      <TableCell
                        style={{
                          color: `${order.paymentId ? "green" : "red"}`,
                          fontWeight: "bold",
                        }}
                      >{`${order.paymentId ? "Paid" : "Not Paid"}`}</TableCell>
                      <TableCell>{order.paymentMethod}</TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>
                        {order.totalPrice?.toLocaleString("en-in", {
                          style: "currency",
                          currency: "INR",
                        })}
                        /-
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[10]} // Only show 10 rows per page
                component="div"
                count={Customer.orders.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                className="actions"
              />
            </TableContainer>
          </div>
        </div>
        <div className="col-xl-3 col-sm-12" >
          <div className="card h-52">
            <div className="card-header">
              <Typography variant="h6">Contact Details</Typography>
            </div>
            <div className="card-body">
              <Typography color="text.secondary" className="font-medium py-2">
                Email :
                {Customer?.orders
                  .slice(0, 1)
                  .map(
                    (order) => order.deliveryAddress?.email || Customer.email
                  )}
              </Typography>
              <Typography color="text.secondary" className="font-medium">
                Phone :{Customer?.phoneNumber}
              </Typography>
              <hr />
              <Typography variant="h6">Order History</Typography>
              <Typography
                color="text.secondary"
                className="font-medium text-xl py-2"
              >
                Total Orders:{" "}
                <span style={{ color: "black" }}>
                  {" "}
                  {Customer.orders.length}
                </span>
              </Typography>
              <Typography
                color="text.secondary"
                className="font-semi-bold text-xl py-2"
              >
                Total Amount Spent:{" "}
                <span style={{ color: "black", fontWeight: "bold" }}>
                  {" "}
                  {Customer.orders
                    .reduce((acc, order) => acc + order.totalPrice, 0)
                    .toLocaleString("en-in", {
                      style: "currency",
                      currency: "INR",
                    })}
                  /-{" "}
                </span>
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
